<template>
  <layouts-header></layouts-header>
  <!-- Breadcrumb -->
  <div class="breadcrumb-bar text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title mb-2">Dashboard</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Dashboard
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="content">
    <div class="container">
      <instructor-header></instructor-header>
      <div class="row">
        <!-- Sidebar -->
        <instructor-sidebar></instructor-sidebar>
        <!-- /Sidebar -->
        <div class="col-lg-9">
          <div class="row">
            <!-- <div class="col-md-6 col-xl-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <span
                      class="icon-box bg-primary-transparent me-2 me-xxl-3 flex-shrink-0"
                    >
                      <img src="@/assets/img/icon/graduation.svg" alt="" />
                    </span>
                    <div>
                      <span class="d-block">Enrolled Courses</span>
                      <h4 class="fs-24 mt-1">12</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="col-md-6 col-xl-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <span
                      class="icon-box bg-secondary-transparent me-2 me-xxl-3 flex-shrink-0"
                    >
                      <img src="@/assets/img/icon/book.svg" alt="" />
                    </span>
                    <div>
                      <span class="d-block">Active Courses</span>
                      <h4 class="fs-24 mt-1">{{ activeCourses }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <span
                      class="icon-box bg-success-transparent me-2 me-xxl-3 flex-shrink-0"
                    >
                      <img src="@/assets/img/icon/bookmark.svg" alt="" />
                    </span>
                    <div>
                      <span class="d-block">New Courses</span>
                      <h4 class="fs-24 mt-1">{{ newCourses }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-md-6 col-xl-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <span
                      class="icon-box bg-info-transparent me-2 me-xxl-3 flex-shrink-0"
                    >
                      <img src="@/assets/img/icon/user-octagon.svg" alt="" />
                    </span>
                    <div>
                      <span class="d-block">Total Students</span>
                      <h4 class="fs-24 mt-1">17</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="col-md-6 col-xl-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <span
                      class="icon-box bg-blue-transparent me-2 me-xxl-3 flex-shrink-0"
                    >
                      <img src="@/assets/img/icon/book-2.svg" alt="" />
                    </span>
                    <div>
                      <span class="d-block">Total Courses</span>
                      <h4 class="fs-24 mt-1">{{ totalCourses }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-md-6 col-xl-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <span
                      class="icon-box bg-purple-transparent me-2 me-xxl-3 flex-shrink-0"
                    >
                      <img src="@/assets/img/icon/money-add.svg" alt="" />
                    </span>
                    <div>
                      <span class="d-block">Total Earnings</span>
                      <h4 class="fs-24 mt-1">$486</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <!-- <div class="card">
            <div class="card-body">
              <div
                class="d-flex align-items-center flex-wrap gap-3 justify-content-between border-bottom mb-2 pb-3"
              >
                <h5 class="fw-bold">Earnings by Year</h5>
                <div class="input-icon position-relative input-range-picker">
                  <span class="input-icon-addon">
                    <i class="isax isax-calendar"></i>
                  </span>
                  <input
                    type="text"
                    class="form-control date-range bookingrange"
                    ref="dateRangeInput"
                    placeholder="dd/mm/yyyy - dd/mm/yyyy"
                  />
                </div>
              </div>
              <div id="earnnings_chart">
                <apexchart
                  type="bar"
                  height="290"
                  :options="earningChart.earnings"
                  :series="earningChart.series"
                >
                </apexchart>
              </div>
            </div>
          </div> -->
          <div class="card">
            <div class="card-body">
              <div
                class="d-flex align-items-center flex-wrap gap-2 justify-content-between border-bottom mb-3 pb-3"
              >
                <h5 class="fw-bold mb-0">Recently Created Courses</h5>
                <router-link
                  to="/instructor/instructor-course"
                  class="btn btn-sm btn-light d-inline-flex align-items-center"
                >
                  View All
                  <i class="isax isax-arrow-right-3 ms-1" aria-hidden="true"></i>
                </router-link>
              </div>

              <div class="table-responsive custom-table">
                <table class="table align-middle mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">Course</th>
                      <th scope="col" class="text-center">Enrolled</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="recentCourses.length === 0">
                      <td colspan="3" class="text-center py-5">
                        <div class="d-flex flex-column align-items-center gap-2">
                          <span
                            class="icon-box bg-secondary-transparent d-inline-flex align-items-center justify-content-center"
                          >
                            <i
                              class="isax isax-book-1 fs-24"
                              aria-hidden="true"
                            ></i>
                          </span>
                          <p class="fw-medium mb-0">No courses created yet.</p>
                          <p class="text-muted fs-14 mb-2">
                            Create your first course to get started.
                          </p>
                          <router-link
                            to="/courses/add-course"
                            class="btn btn-sm btn-secondary"
                          >
                            Add Course
                          </router-link>
                        </div>
                      </td>
                    </tr>
                    <tr
                      v-for="(item, index) in recentCourses"
                      :key="item.course_id || index"
                    >
                      <td>
                        <div class="d-flex align-items-center min-w-0">
                          <router-link
                            :to="{
                              name: 'CourseDetail',
                              params: { course_id: item.course_id },
                            }"
                            class="avatar avatar-lg me-2 flex-shrink-0 overflow-hidden rounded"
                          >
                            <img
                              class="img-fluid object-fit-cover"
                              :src="`${authStore.Url}/media/${item.thumbnail}`"
                              :alt="item.title || 'Course thumbnail'"
                            />
                          </router-link>
                          <div class="min-w-0">
                            <h6 class="fw-medium mb-1 text-truncate">
                              <router-link
                                :to="{
                                  name: 'CourseDetail',
                                  params: { course_id: item.course_id },
                                }"
                                :title="item.title"
                              >
                                {{ item.title }}
                              </router-link>
                            </h6>
                            <span
                              v-if="item.level"
                              class="d-inline-flex fs-12 align-items-center text-muted text-nowrap"
                            >
                              <i
                                class="isax isax-video-circle me-1 text-gray-9 fw-bold"
                                aria-hidden="true"
                              ></i>
                              {{ item.level }}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td class="text-center">
                        <span
                          class="d-inline-flex align-items-center justify-content-center gap-1 text-nowrap"
                          :aria-label="`${item.student_enrolled_count || 0} students enrolled`"
                        >
                          <i
                            class="isax isax-people text-gray-9"
                            aria-hidden="true"
                          ></i>
                          {{ item.student_enrolled_count || 0 }}
                        </span>
                      </td>
                      <td>
                        <span
                          class="badge badge-sm d-inline-flex align-items-center text-nowrap"
                          :class="statusBadgeClass(item.status)"
                        >
                          <i
                            class="fa-solid fa-circle fs-5 me-1"
                            aria-hidden="true"
                          ></i>
                          {{ item.status || "—" }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <footer-two></footer-two> -->
</template>
<script>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref } from "vue";
import { onMounted } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import { computed } from "vue";
import { useCourseFetchStore } from "@/stores/course/course-fetch-store";
import { useAuthStore } from "@/stores/auth-store";

export default {
  methods: {
    toggleHeader() {
      document.getElementById("collapse-header").classList.toggle("active");
      document.body.classList.toggle("header-collapse");
    },
    statusBadgeClass(status) {
      const map = {
        Active: "bg-success",
        New: "bg-warning",
        Disabled: "bg-danger",
      };
      return map[status] || "bg-secondary";
    },
  },
  setup() {
    const courseFetchStore = useCourseFetchStore();
    const authStore = useAuthStore();

    const dateRangeInput = ref(null);

    // Move the function declaration outside of the onMounted callback
    function booking_range(start, end) {
      return start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
    }

    onMounted(() => {
      if (dateRangeInput.value) {
        const start = moment().subtract(6, "days");
        const end = moment();

        new DateRangePicker(
          dateRangeInput.value,
          {
            startDate: start,
            endDate: end,
            ranges: {
              Today: [moment(), moment()],
              Yesterday: [
                moment().subtract(1, "days"),
                moment().subtract(1, "days"),
              ],
              "Last 7 Days": [moment().subtract(6, "days"), moment()],
              "Last 30 Days": [moment().subtract(29, "days"), moment()],
              "This Month": [
                moment().startOf("month"),
                moment().endOf("month"),
              ],
              "Last Month": [
                moment().subtract(1, "month").startOf("month"),
                moment().subtract(1, "month").endOf("month"),
              ],
            },
          },
          booking_range
        );

        booking_range(start, end);
      }
      //API Call
      courseFetchStore.fetchCourseByCreatorList();
    });

    const activeCourses = computed(() => {
      return courseFetchStore.courseCreatedList.filter(
        (c) => c.status === "Active"
      ).length;
    });

    const newCourses = computed(() => {
      return courseFetchStore.courseCreatedList.filter(
        (c) => c.status === "New"
      ).length;
    });

    const totalCourses = computed(() => {
      return courseFetchStore.courseCreatedList.length;
    });

    const recentCourses = computed(() => {
      return courseFetchStore.courseCreatedList.slice(0, 5);
    });

    return {
      dateRangeInput,
      courseFetchStore,
      authStore,
      activeCourses,
      newCourses,
      totalCourses,
      recentCourses,
    };
  },
};
</script>
